var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgCreatroUser = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M7.112 9.624a3.13 3.13 0 1 0 0-6.262 3.13 3.13 0 0 0 0 6.262ZM1.636 16.05l.669-2.494A2.64 2.64 0 0 1 4.852 11.6h4.522c1.193 0 2.238.801 2.547 1.955l.67 2.494" }), _jsx("path", { fill: "currentColor", d: "M14.5 0c0 2.761 1.567 5 3.5 5-1.933 0-3.5 2.239-3.5 5 0-2.761-1.567-5-3.5-5 1.933 0 3.5-2.239 3.5-5" })] }))); };
export default SvgCreatroUser;
